import * as Yup from 'yup';
import {PlaybookStatus} from '../types';

export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          status: Yup.string()
                                                     .oneOf(Object.values(PlaybookStatus))
                                                     .required('Please select a status'),
                                      });
